// loan app
export const API_ROOT = {
  root: '/',
  auth: '/api/authpresentation/',
  app: '/Underwriter/LoanApplications/',
  admin: '/Admin/',
  queues: '/Underwriter/LoanApplications/',
  held: '/underwriter/HeldInboundApps/',
  manual: '/underwriter/ManualAppEntry/',
  vehicle: '/vehicleInfo/',
  publishRules: '/admin/publishRules/',
  lookupTables: '/admin/lookupTables/',
  decisionHistoryPage: '/admin/selectionAdmin/',
  collateral: '/collateral/',
  vfApp: '/funder/LoanApplications/',
  crosssellconfiguration: '/admin/crosssellconfiguration/'
};

// auth api
export const ACCOUNT_USER = 'user';
export const ACCOUNT_TOKEN = 'token';
export const ACCOUNT_PING = 'ping';
export const ACCOUNT_LOGOUT = 'account/logout';
export const ACCOUNT_CHANGE_PASSWORD = 'account/password';
export const ACCOUNT_RESET_PASSWORD = 'account/resetpassword';

// Requires UserName
export const ACCOUNT_FORGOT_PW = 'account/forgotpassword';

// Requires UserName & Password
export const ACCOUNT_FORGOT_PW_CONFIRM = 'account/forgotpassword/confirm';
export const ACCOUNT_LOGIN = 'token';
export const VALIDATE_MFA_CODE = 'token/validatemfa';
export const LOGIN_HELP_TEXT = 'home/getlogintext';
export const LOGIN_BACKGROUND_IMG = 'home/getbackground';
export const HOME_UNLOCK = 'Home/Unlock?loanApplicationId=';